// extracted by mini-css-extract-plugin
export default {"upload-input":"styles_upload-input__dYsjG","chat-button":"styles_chat-button__uAho1","icon":"styles_icon__wx6Jw","send-btn-disabled":"styles_send-btn-disabled__qJwEI"};